import BaseUIHandler from '../BaseUIHandler';
import GameObject, { GameObjectEvent } from '../../../GameObject/GameObject';
import { UIActions } from '../../../State/UI/UIActions';
import Game from '../../../Game';
import Renderable from '../../../Component/Renderable';
import { StartAnimation, StartAnimationClip } from '../../Animation/AnimationHelper';
import BaseUISystem, { UIEvent } from '../BaseUISystem';
import IPlayerSocialData, { IFriendData } from '../../../Player/PlayerProperty/Social/IPlayerSocialData';
import { SagaMapContainers } from '../../../Prototype/World/WorldMap';
import FriendIcon from '../../../Prototype/World/FriendIcon';
import HarvestButton from '../../../Prefabs/UI/HUD/HarvestButton';
import Element from '../../../Prototype/UI/Element';
import RenderSystem, { RenderSystemEvent } from '../../Render/RenderSystem';
import ElementComponent from '../../../Component/UI/Element';
import PIXIRenderer from '../../Render/PIXIRenderer';
import { AnimationClipEvent } from '../../Animation/AnimationClip';
import CoinBar from '../../../Prefabs/UI/HUD/CoinBar';
import NextLevelButton from '../../../Prefabs/UI/HUD/NextLevelButton';
import SettingsButton from '../../../Prefabs/UI/HUD/SettingsButton';
import FriendsHubButton from '../../../Prefabs/UI/HUD/FriendsHubButton';
import ShopButton from '../../../Prefabs/UI/HUD/ShopButton';
import { IGameState } from '../../../State/Game/IGameState';
import StarChestProgressBar from '../../../Prefabs/UI/HUD/StarChestProgressBar';
import FutureStarChest from '../../../Prefabs/StarChest/FutureStarChest';
import { WorldDataHelper } from '../../../Utility/WorldDataHelper';
import { StarChestEvent, StarChestHelper } from '../../../Utility/StarChestHelper';
import StarChest from '../../../Prefabs/StarChest/StarChest';
import { StarChestUpgrade, StarChestUpgradeParams } from '../../Animation/Clip';
import { STAR_CHEST_TIER_DATA } from '../../../Constants/Chests';
import SundayOfferButton from '../../../Prefabs/UI/HUD/SundayOfferButton';
import PayerReactivationOfferIcon from '../../../Prefabs/UI/HUD/PayerReactivationOfferIcon';
import { QuestStateHelper } from 'State/Player/Quests/QuestStateHelper';
import { StarChestStateHelper } from 'State/Player/StarChests/StarChestStateHelper';
import { IAPStateHelper } from 'State/Player/IAP/IAPStateHelper';
import { PopupID } from '../../../State/UI/PopupID';
import { ThemeSettings } from 'Constants/Theme';
import { SHOP_UNLOCK_LEVEL } from 'Constants/Shop';
import { Platform } from 'Utility/Platform';
import FarmButton from 'Prefabs/UI/HUD/FarmButton';
import ConnectFbPopup from 'System/UI/Menu/ConnectFbPopup';
import Sprite from 'Prototype/Sprite';
import { Point } from 'pixi.js';
import Interactable from 'Component/Interactable';
import { applyDefaultButtonAnimation } from 'System/UI/UIHelper';
import { EventOfferButton } from 'Prefabs/UI/HUD/EventOfferButton';
import QuestButton from 'Prefabs/UI/HUD/Quests/QuestButton';

export default class WorldHUDHandler extends BaseUIHandler {
    public mainContainer: Element;
    private cropContainer: Element;
    private futureStarChestBubble: FutureStarChest | null = null;
    private readonly toCallOnDestroy = new Array<() => void>();
    public harvestButton: HarvestButton;
    public farmButton: FarmButton;

    public static SUNDAY_OFFER_BTN_NAME: string = 'sunday_offer_button';
    public static NEXT_LEVEL_BTN_NAME: string = 'next_level';
    public static COIN_BAR_BTN_NAME: string = 'coin_bar';
    public static CROP_CONTAINER: string = 'world_HUD_crop_container';
    public static SETTINGS_BTN_NAME: string = 'settings_button';
    public static FREE_COIN_BUTTON: string = 'free_coin_button';
    public static STAR_CHEST_PROGRESS_BAR: string = 'star_chest_progress_bar';
    public static QUESTS_BTN_NAME: string = 'quests_button';
    private connectFbIcon: GameObject | null = null;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.WORLD_HUD, uiSystem, false);
        this.alwaysVisible = true;

        /* this.system.scene.on(
            TaskEvents.START,
            this.onTaskStatusChange.bind(this, true)
        );
        this.system.scene.on(
            TaskEvents.COMPLETE,
            this.onTaskStatusChange.bind(this, false)
        ); */
        this.system.scene.on(UIEvent.HIDE_HUD, this.hideHUD);

        // Preload particle data if there is any defined in theme settings
        if (ThemeSettings.HARVEST_BUTTON_PARTICLE_RESOURCE_DATA) {
            this.resources.set(
                ThemeSettings.HARVEST_BUTTON_PARTICLE_RESOURCE_DATA.key,
                ThemeSettings.HARVEST_BUTTON_PARTICLE_RESOURCE_DATA.path
            );
        }
    }

    protected onCreate() {
        this.mainContainer = GameObject.Instantiate(Element, {
            name: 'world_HUD_main_container',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0, 0],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
            },
        });
        this.cropContainer = GameObject.Instantiate(Element, {
            name: WorldHUDHandler.CROP_CONTAINER,
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
            },
        });

        this.element.addChild(this.cropContainer);
        this.element.addChild(this.mainContainer);
        RenderSystem.on(RenderSystemEvent.RESIZE, this.onResize.bind(this));
        super.onCreate();
        this.onResize();
        this.handleInteractables();
    }

    public handleStateChanged(state: IGameState): void {
        super.handleStateChanged(state);

        this.futureStarChestBubble?.updateAnchors(StarChestHelper.getFutureChestAnchor(state));
        this.harvestButton?.handleHarvest(state);
        this.updateFriendIcons(state.playerState.social);

        if (this.connectFbIcon) {
            this.connectFbIcon.getComponent(Renderable).visible = ConnectFbPopup.canShow();
        }

        /* if (
            state.context.response &&
            state.context.response.responseType ===
                ResponseType.SUBSCRIBE_BOT_OPT_IN &&
            state.context.response.status === ResponseStatus.SUCCESS
        ) {
            const btnBotOptIn: GameObject = this.element.find(
                this.botOptInParams.name
            );
            btnBotOptIn.getComponent(Renderable).visible = false;
        } */
        this.onResize();
    }

    private updateFriendIcons(state: IPlayerSocialData): void {
        const friendContainer: GameObject = GameObject.findByName(SagaMapContainers.FRIEND_ICON_CONTAINER)[0];
        friendContainer.children.forEach((friend: FriendIcon) => {
            if (friend.enableSend) {
                const friendData = state.friendData.find((data: IFriendData) => data.playerId === friend.friendId);
                friend.enableSend(!friendData || friendData.giftCooldown === null);
            }
        });
    }

    private handleInteractables(): void {
        const highestLevel: number = Game.player.getHighestLevelCompleted();
        const state: IGameState = Game.store.getState();

        this.futureStarChestBubble = this.createFutureStarChestBubble();

        const newCoinBar: CoinBar = GameObject.Instantiate(CoinBar, {
            name: WorldHUDHandler.COIN_BAR_BTN_NAME,
            layout: {
                anchors: [0.17, 0.06, 0.17, 0.06],
            },
        });

        const newStarChestProgressBar: StarChestProgressBar = GameObject.Instantiate(StarChestProgressBar, {
            name: WorldHUDHandler.STAR_CHEST_PROGRESS_BAR,
            layout: {
                anchors: [0.55, 0, 0.55, 0],
            },
        });

        this.harvestButton = GameObject.Instantiate(HarvestButton, { scene: this.system.scene });
        this.farmButton = GameObject.Instantiate(FarmButton, { scene: this.system.scene });

        const nextLevelBtn: NextLevelButton = GameObject.Instantiate(NextLevelButton, {
            name: WorldHUDHandler.NEXT_LEVEL_BTN_NAME,
            layout: {
                anchors: [0.93, 0.92, 0.93, 0.92],
            },
            highestLevel,
        });
        const settingsBtn: SettingsButton = GameObject.Instantiate(SettingsButton, {
            name: WorldHUDHandler.SETTINGS_BTN_NAME,
            layout: {
                anchors: [0.05, 0.93, 0.05, 0.93],
            },
        });
        if (highestLevel >= SHOP_UNLOCK_LEVEL) {
            const shopBtn: ShopButton = GameObject.Instantiate(ShopButton, {
                name: 'shop',
                layout: {
                    anchors: [0.65, 0.92, 0.65, 0.92],
                },
                highestLevel,
            });
            this.mainContainer.addChild(shopBtn);
        }

        if (this.futureStarChestBubble) {
            this.mainContainer.addChild(this.futureStarChestBubble);
        }
        this.mainContainer.addChild(newCoinBar);
        this.mainContainer.addChild(newStarChestProgressBar);
        this.mainContainer.addChild(this.harvestButton);
        this.mainContainer.addChild(this.farmButton);
        this.mainContainer.addChild(nextLevelBtn);
        this.mainContainer.addChild(settingsBtn);

        if (ConnectFbPopup.canShow()) {
            this.createConnectFbIcon();
        }

        this.addFriendsHubBtn();

        if (QuestStateHelper.isQuestsFeatureUnlocked(state.playerState)) {
            const questButton = GameObject.Instantiate(QuestButton, { scene: this.system.scene });
            this.mainContainer.addChild(questButton);
        }

        const availableEventOffer = IAPStateHelper.getHighestPrioEventWithAvailableOffer(state);
        if (availableEventOffer && IAPStateHelper.isEventOfferAvailable(state)) {
            const eventOfferBtn = GameObject.Instantiate(EventOfferButton, {
                eventType: availableEventOffer.type,
                x: 100,
                y: 200,
            });
            this.mainContainer.addChild(eventOfferBtn);
        }

        if (IAPStateHelper.isSundayOfferAvailable(state)) {
            const sundayOfferBtn: SundayOfferButton = GameObject.Instantiate(SundayOfferButton, {
                name: WorldHUDHandler.SUNDAY_OFFER_BTN_NAME,
                layout: {
                    anchors: availableEventOffer ? [0.19, 0.265, 0.19, 0.265] : [0.06, 0.25, 0.06, 0.25],
                },
                scene: this.system.scene,
            });
            this.mainContainer.addChild(sundayOfferBtn);
        } else if (IAPStateHelper.isPayerReactivationOfferAvailable(state)) {
            const offer = GameObject.Instantiate(PayerReactivationOfferIcon, { x: 75, y: availableEventOffer ? 350 : 200 });
            this.mainContainer.addChild(offer);
        }
    }

    private createConnectFbIcon(): void {
        this.connectFbIcon = GameObject.Instantiate(Sprite, {
            texture: 'fbconnect_icon_map',
            anchor: new Point(0.5, 0.5),
            relativePosition: new Point(0.058, 0.56),
        });
        this.connectFbIcon.addComponent(Renderable);
        this.connectFbIcon.addComponent(Interactable);
        this.mainContainer.addChild(this.connectFbIcon);
        applyDefaultButtonAnimation(this.connectFbIcon);

        const interactable = this.connectFbIcon.getComponent(Interactable);
        interactable.toggleable = true;
        interactable.enabled = true;
        interactable.buttonMode = true;

        this.connectFbIcon.on(GameObjectEvent.SELECTED, () => {
            UIActions.showPopup(PopupID.CONNECT_FB_POPUP, {});
        });
    }

    private addFriendsHubBtn() {
        if (Game.config.platform === Platform.ANDROID || Game.config.platform == Platform.IOS) {
            return;
        }
        const friendsHubBtn: FriendsHubButton = GameObject.Instantiate(FriendsHubButton, {
            name: 'friends_hub',
            layout: {
                anchors: [0.06, 0.5, 0.06, 0.5],
            },
        });
        // this.mainContainer.addChild(friendsHubBtn);
    }

    /*
    private onBotOptInClick(): void {
        UIActions.showPopup('botOptInMenu');
    }

    private onTaskStatusChange(isRunning: boolean) {
        try {
            this.element
                .getComponentsInChildren(Interactable)
                .forEach((interactable: Interactable) =>
                    interactable.toggle(isRunning ? !isRunning : undefined)
                );
        } catch (e) {
            console.warn('Interactables not created yet', e);
        }
    }
    */

    private readonly hideHUD = (value: boolean): void => {
        const mainRenderable: Renderable = this.mainContainer.getComponent<Renderable>(Renderable);

        StartAnimation(this.mainContainer, 'Alpha', {
            startAlpha: Number(value),
            endAlpha: Number(!value),
            duration: 250,
        }).once(AnimationClipEvent.COMPLETE, () => (mainRenderable.visible = !value));
    };

    public destroy(): void {
        const toCallOnDestroy = [...this.toCallOnDestroy];
        this.toCallOnDestroy.length = 0;
        for (let i = toCallOnDestroy.length - 1; i >= 0; i -= 1) {
            toCallOnDestroy[i]();
        }
        super.destroy();
        RenderSystem.off(RenderSystemEvent.RESIZE);
    }

    public onResize(): void {
        if (!this.mainContainer.destroyed) {
            this.mainContainer.container.resize(
                PIXIRenderer.renderer.width,
                PIXIRenderer.renderer.height - PIXIRenderer.borderHeight * 2
            );

            this.mainContainer.children.forEach(child => {
                if (child instanceof Element) {
                    child.container.resize(
                        PIXIRenderer.renderer.width,
                        PIXIRenderer.renderer.height - PIXIRenderer.borderHeight * 2
                    );
                }
            });
            this.mainContainer.getComponent(ElementComponent).offsets = [
                0,
                -PIXIRenderer.borderHeight,
                0,
                -PIXIRenderer.borderHeight,
            ];
        }
        if (!this.cropContainer.destroyed) {
            this.cropContainer.container.resize(
                PIXIRenderer.renderer.width,
                PIXIRenderer.renderer.height - PIXIRenderer.borderHeight * 2
            );
        }
    }

    /*
    import { IButtonData } from '../../../Prototype/UI/BaseElements/Button';
    private readonly botOptInParams: IButtonData = {
        name: 'bot_opt_in',
        cacheKey: 'HUD_bot_opt_in',
        enabled: true,
        layout: {
            anchors: [1, 0.63, 1, 0.63],
            pivot: [1, 0.5],
            offsets: [-5, 0, -5, 0],
            scale: [0.95, 0.95],
        },
        textData: {
            name: 'text',
            textLocalizationKey: 'SUBSCRIBE',
            layout: {
                offsets: [-25, -125, -25, -125],
            },
            style: {
                font: 'FrancoisOne',
                fill: '#fcffd9',
                fontSize: '46px',
            },
        },
    };
    */

    private createFutureStarChestBubble(): FutureStarChest | null {
        const state = Game.store.getState();

        const maxLevelNumberFromWorld = WorldDataHelper.maxLevel(state.worldState.worldNumber);
        const starChestLevel = state.playerState.starChestLevel;

        if (starChestLevel === null || starChestLevel <= maxLevelNumberFromWorld) {
            return null;
        }

        /** Star Chest tier to display when world is created.
         * If stars gained from the previous level are enough to upgrade the chest
         * Then the tier below the current tier should be displayed initially
         * This is so an upgrade animation may be shown */
        const currentTier = StarChestStateHelper.getStarChestUnlockTier(
            state.playerState,
            state.worldState.starsGained
        );

        const newFutureStarChest = GameObject.Instantiate(FutureStarChest, {
            name: 'future_star_chest',
            layout: { anchors: StarChestHelper.getFutureChestAnchor(state) },
            tier: currentTier,
            text: Game.locale.getText('StarChestReachLevelX').replace('[X]', String(starChestLevel)),
        });
        const starChestAnimated = GameObject.Instantiate(StarChest, {
            name: 'star_chest',
            layout: {
                anchors: [0.5, 0.1, 0.5, 0.1],
                scale: STAR_CHEST_TIER_DATA[currentTier].futureChestScale,
            },
            tier: currentTier,
        });
        newFutureStarChest.addChild(starChestAnimated);
        Game.scene.getActiveScene().on(StarChestEvent.UPGRADE_CHEST, (meta: StarChestUpgradeParams) => {
            StartAnimationClip(new StarChestUpgrade(starChestAnimated, meta));
        });
        this.addListener(newFutureStarChest, GameObjectEvent.SELECTED, () => {
            UIActions.showPopup(PopupID.STAR_CHEST_INFO, {
                levelNumber: starChestLevel,
            });
        });
        return newFutureStarChest;
    }

    private addListener(emitter: GameObject, event: string, listener: () => void) {
        emitter.on(event, listener);
        this.toCallOnDestroy.push(() => {
            emitter.off(event, listener);
        });
    }
}
